export default __webpack_public_path__ + "static/media/plan-bg.41b064d8.svg";